<template>
  <nav class="navigation-sub">
    <div class="navigation-sub-list">
      <template v-for="(item, i) in list">
        <router-link
          v-if="item.link"
          :key="i"
          :to="item.link"
          class="navigation-sub-item"
          active-class="active"
        >
          {{ item.title }}
        </router-link>
        <a
          v-else
          :key="i"
          class="navigation-sub-item"
          :class="{
            active: activeIndex === i
          }"
          :href="`#${hashTitle(item.anchor ? item.anchor : item.title)}`"
          @click="onScrollEnd"
        >{{ item.title }}
        </a>
      </template>
    </div>
  </nav>
</template>

<script>
import { hashTitle } from '@/util'

export default {
  props: {
    isAnchor: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      activeIndex: -1,
      articleMap: []
    }
  },
  watch: {
    $route () {
      this.activeIndex = -1
    }
  },
  mounted () {
    if (this.isAnchor) {
      this.init()
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollEvent)
  },
  methods: {
    hashTitle,
    init () {
      this.setArticleMap()

      window.addEventListener('scroll', this.scrollEvent)
    },
    setArticleMap () {
      return new Promise(resolve => {
        this.articleMap = this.list.map(item => {
          const anchor = document.getElementById(hashTitle(item.anchor ? item.anchor : item.title))
          return anchor ? Math.abs(anchor.offsetTop) : 0
        })

        resolve(this.articleMap)
      })
    },
    scrollEvent (e) {
      const doc = document.documentElement
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'))
      const scrollTop = Math.abs(doc.scrollTop) + headerHeight + 50 // + doc.clientHeight

      this.setArticleMap()

      this.activeIndex = this.articleMap.findLastIndex(v => v <= scrollTop)
    },
    onScrollEnd (e) {
      e.preventDefault()

      const anchor = document.querySelector(decodeURIComponent(e.target.hash))
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'))
      const scrollMarginGap = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--scroll-margin-gap'))
      const scrollTop = Math.abs(anchor.offsetTop) - (headerHeight + scrollMarginGap)

      document.documentElement.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      })

      setTimeout(() => {
        this.$root.$emit('header:show')
      }, 810)
    },
  }
}
</script>
